import {classNames} from '@cohort/shared-frontend/utils/classNames';
import useThemeContext from '@cohort/wallet/hooks/useThemeContext';
import React from 'react';

interface EmptySectionProps {
  icon: JSX.Element;
  title?: string;
  subtitle?: string;
  cta?: JSX.Element;
}

const EmptySection: React.FC<EmptySectionProps> = ({icon, title, subtitle, cta}) => {
  const {hasDarkBg} = useThemeContext();

  return (
    <div className="h-full w-full">
      <div
        className={classNames(
          'group relative inline-flex w-full flex-col items-center rounded-lg p-12 text-center transition duration-150 focus:outline-none',
          hasDarkBg ? 'bg-white/8' : 'bg-black/4'
        )}
      >
        {icon}
        {title && (
          <span
            className={classNames(
              'mt-2 block text-sm font-medium',
              hasDarkBg ? 'text-white' : 'text-black'
            )}
          >
            {title}
          </span>
        )}

        {subtitle && (
          <span
            className={classNames(
              'mt-2 block text-sm font-medium',
              hasDarkBg ? 'text-white/60' : 'text-black/60'
            )}
          >
            {subtitle}
          </span>
        )}

        {cta && <div className="mt-5">{cta}</div>}
      </div>
    </div>
  );
};

export default EmptySection;
